import React, { useState, useEffect } from 'react';
import './App.css';

const Header = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const slides = [
    {
      image: '/images/DDWedding/DDwedding-11.jpg',
      title: 'Our Special Day',
      description: 'Join us in celebrating our love'
    },
    {
      image: '/images/GAwedding/GAwedding-8.jpg',
      title: 'Just Married',
      description: 'Walking out as husband and wife.'
    },
    {
      image: '/images/hotelshooting-8.jpg',
      title: 'Modern Comfort',
      description: 'Captured for real estate showcase – Hampton by Hilton at its best.'
    }
  ];

  useEffect(() => {
    console.log('Header component mounted');
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [slides.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <header className="header" style={{ minHeight: '100vh', backgroundColor: '#f0f0f0' }}>
      <div className="carousel-container" style={{ height: '100vh', position: 'relative' }}>
        <div 
          className="carousel-slide"
          style={{ 
            transform: `translateX(-${currentSlide * 100}%)`,
            display: 'flex',
            width: '100%',
            height: '100%'
          }}
        >
          {slides.map((slide, index) => (
            <div 
              key={index} 
              className="carousel-item"
              style={{
                minWidth: '100%',
                height: '100%',
                position: 'relative'
              }}
            >
              <img 
                src={slide.image} 
                alt={slide.title} 
                className="carousel-image"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover'
                }}
                loading="lazy"
                onError={(e) => console.error('Image failed to load:', slide.image)}
              />
              <div 
                className="carousel-overlay"
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background: 'linear-gradient(to bottom, rgba(0,0,0,0.3), rgba(0,0,0,0.5))'
                }}
              />
              <div 
                className="carousel-content"
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  textAlign: 'center',
                  color: 'white',
                  zIndex: 2
                }}
              >
                <h1 style={{ fontSize: '3rem', marginBottom: '1rem' }}>{slide.title}</h1>
                <p style={{ fontSize: '1.5rem' }}>{slide.description}</p>
              </div>
            </div>
          ))}
        </div>
        
        <button 
          className="carousel-button prev" 
          onClick={prevSlide}
          aria-label="Previous slide"
          style={{
            position: 'absolute',
            top: '50%',
            left: '20px',
            transform: 'translateY(-50%)',
            background: 'rgba(255, 255, 255, 0.3)',
            border: 'none',
            width: '50px',
            height: '50px',
            borderRadius: '50%',
            cursor: 'pointer',
            color: 'white',
            fontSize: '1.5rem',
            zIndex: 3
          }}
        >
          <i className="fas fa-chevron-left"></i>
        </button>
        <button 
          className="carousel-button next" 
          onClick={nextSlide}
          aria-label="Next slide"
          style={{
            position: 'absolute',
            top: '50%',
            right: '20px',
            transform: 'translateY(-50%)',
            background: 'rgba(255, 255, 255, 0.3)',
            border: 'none',
            width: '50px',
            height: '50px',
            borderRadius: '50%',
            cursor: 'pointer',
            color: 'white',
            fontSize: '1.5rem',
            zIndex: 3
          }}
        >
          <i className="fas fa-chevron-right"></i>
        </button>
        
        <div 
          className="carousel-indicators"
          style={{
            position: 'absolute',
            bottom: '20px',
            left: '50%',
            transform: 'translateX(-50%)',
            display: 'flex',
            gap: '10px',
            zIndex: 3
          }}
        >
          {slides.map((_, index) => (
            <button
              key={index}
              className={`indicator ${index === currentSlide ? 'active' : ''}`}
              onClick={() => setCurrentSlide(index)}
              aria-label={`Go to slide ${index + 1}`}
              style={{
                width: '12px',
                height: '12px',
                borderRadius: '50%',
                background: index === currentSlide ? 'white' : 'rgba(255, 255, 255, 0.5)',
                border: 'none',
                cursor: 'pointer'
              }}
            />
          ))}
        </div>
      </div>
    </header>
  );
};

export default Header;
